// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClearOutlinedSvg from "@fishx/icons-svg/es/asn/ClearOutlined";
import FishxIcon from '../components/FishxIcon';

var ClearOutlined = function ClearOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClearOutlinedSvg
  }));
};

ClearOutlined.displayName = 'ClearOutlined';
export default React.forwardRef(ClearOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ClearOutlined.js
// module id = 2219
// module chunks = 0